import dayjs from 'dayjs';

const legendaryKitties = [
  1661936756, 1661937207, 1661937460, 1661939156, 1661939241, 1661939377, 1661940297, 1661941386, 1661942679, 1661947194, 1661947770, 1661949117,
  1661949474, 1661951060, 1661951539, 1661951910, 1661951936, 1661957336, 1661963776, 1661968110, 1661968410, 1661971196, 1661973004, 1661974278,
  1661974727, 1661976067, 1661978596, 1661986709, 1661996104, 1661999788, 1662007488, 1662016074, 1662016339, 1662017724, 1662024948, 1662025186,
  1662029034, 1662033257, 1662037649, 1662037671, 1662040793, 1662046048, 1662046996, 1662047482, 1662047904, 1662047920, 1662059942, 1662060989,
  1662061053, 1662063859,
];

export const getTreatsEarnedPerDay = (kitty, city) => {
  if (!kitty) {
    return { treatsPerDay: 0, bonusTreats: null };
  }

  if (kitty.isCollab) {
    return { treatsPerDay: 2, bonusTreats: null };
  }

  if (kitty.isAccessory) {
    return { treatsPerDay: 1, bonusTreats: null };
  }

  let treatsPerDay = 2; // Base Amount - 2 treats per day
  const level = kitty?.bio?.level || 1;

  if (level === 1 || level === 2) {
    treatsPerDay = 2;
  } else if (level === 3 || level === 4) {
    treatsPerDay = 4;
  } else if (level === 5 || level === 6 || level === 7) {
    treatsPerDay = 6;
  } else if (level === 8) {
    treatsPerDay = 10;
  } else if (level === 9) {
    treatsPerDay = 15;
  } else if (level === 10) {
    treatsPerDay = 20;
  }

  if (kitty.rank >= 1 && kitty.rank <= 10) {
    treatsPerDay = 15;
  } else if (kitty.rank >= 11 && kitty.rank <= 100) {
    treatsPerDay = 8;
  }

  if (legendaryKitties.includes(kitty.id)) {
    treatsPerDay = 15;
  }

  // Get the city's internal rating.
  const cityRating = city.rarityScore;

  // Define the sigmoid function for scaling the bonus multiplier.
  const sigmoid = (x) => 1 / (1 + Math.exp(-x));

  // Define a scaling factor to control the steepness of the sigmoid curve.
  const scalingFactor = 0.2;

  // Calculate the bonus multiplier using the sigmoid function.
  const bonusMultiplier = sigmoid(cityRating * scalingFactor);
  const originalTreats = treatsPerDay;
  const bonusTreats = Math.round(treatsPerDay * (1 + bonusMultiplier));

  // Apply the bonus multiplier to the treatsPerDay.
  if (bonusTreats) {
    treatsPerDay = bonusTreats;
  }

  return { treatsPerDay, bonusTreats: bonusTreats - originalTreats };
};

const calculateClaimableTreats = (kitty, city, date) => {
  const now = dayjs();
  const lastClaimedDate = dayjs(date);
  const diff = now.diff(lastClaimedDate, 'day');
  const { treatsPerDay } = getTreatsEarnedPerDay(kitty, city);
  const claimableTreats = diff * treatsPerDay;
  return typeof claimableTreats === 'number' ? claimableTreats : 0;
};

export default calculateClaimableTreats;
